export * from './hooks';
export * from './plugins';
export * from './types';

import { ZodiosHooks } from '@zodios/react';
import { createApiClient } from '../codegen/person-api';
import { interceptorWithToken } from './plugins';

export { schemas as apiSchemas } from '../codegen/person-api';

const API_HOST = process.env.NEXT_PUBLIC_API_HOST || 'http://localhost:8080'; // Fallback to localhost
if (!API_HOST && process.env.NODE_ENV !== 'test') {
  throw new Error('Please provide the API host');
}

let _getApiToken: (() => Promise<string | undefined>) | undefined;

export const api = createApiClient(API_HOST, {
  axiosConfig: { paramsSerializer: { indexes: null } },
});
export const hooksApi = new ZodiosHooks('personApi', api);

// Plugin registered once at module init. Token getter populated by configureApiAuth()
// before any component effects fire.
api.use(interceptorWithToken({ getToken: () => _getApiToken?.() ?? Promise.resolve(undefined) }));

export function configureApiAuth(getToken: () => Promise<string | undefined>) {
  _getApiToken = getToken;
}
